<script setup lang="ts">
import { AlertTriangle } from 'lucide-vue-next';
import ModalShell from './ModalShell.vue';

withDefaults(
  defineProps<{
    open: boolean;
    title: string;
    message: string;
    confirmLabel: string;
    cancelLabel: string;
    isLoading?: boolean;
    isError?: boolean;
  }>(),
  { isLoading: false, isError: false },
);

const emit = defineEmits<{ confirm: []; cancel: [] }>();
</script>

<template>
  <ModalShell :open="open" max-width="sm" @close="emit('cancel')">
    <div class="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-red-900/30 rounded-full">
      <AlertTriangle class="w-6 h-6 text-red-400" />
    </div>
    <h3 class="text-lg font-semibold text-[#F5F0EA] text-center mb-2">{{ title }}</h3>
    <p :class="['text-center mb-6', isError ? 'text-red-400' : 'text-[#524840]']">
      {{ message }}
    </p>
    <div class="flex gap-3">
      <button
        type="button"
        class="flex-1 py-2.5 px-4 bg-[#1E1E23] hover:bg-[#2A2018] text-[#9E9080] rounded-xl transition font-medium"
        @click="emit('cancel')"
      >
        {{ cancelLabel }}
      </button>
      <button
        type="button"
        :disabled="isLoading"
        class="flex-1 py-2.5 px-4 bg-red-600 hover:bg-red-700 disabled:bg-red-400 text-[#F5F0EA] rounded-xl transition font-medium"
        @click="emit('confirm')"
      >
        {{ confirmLabel }}
      </button>
    </div>
  </ModalShell>
</template>
